import {
  SELECTED_LANGUAGE_STORAGE_KEY,
  type SupportedLanguage
} from '@/i18n/constants';

interface AuthorizationConfig {
  Auth: {
    cognitoDomain: string | undefined;
    userPoolId: string | undefined;
    userPoolWebClientId: string | undefined;
  };
}

interface DefaultConfig {
  authorization: AuthorizationConfig;
  i18n: {
    fallbackLocale: SupportedLanguage;
    // Raw value read from localStorage — may be any leftover string (legacy code,
    // user tampering, cross-app pollution). Normalised to SupportedLanguage by
    // normalizeAndMigrateSelectedLanguage in src/i18n/index.ts.
    selectedLanguage: string | null;
  };
  timezone: {
    default: string;
  };
  defaultBusinessCountries: string[];
}

const { VITE_COGNITO_DOMAIN, VITE_COGNITO_POOL_ID, VITE_COGNITO_CLIENT_ID } =
  import.meta.env;

const defaultConfig: DefaultConfig = {
  authorization: {
    Auth: {
      cognitoDomain: VITE_COGNITO_DOMAIN,
      userPoolId: VITE_COGNITO_POOL_ID,
      userPoolWebClientId: VITE_COGNITO_CLIENT_ID
    }
  },
  i18n: {
    fallbackLocale: 'en',
    selectedLanguage: localStorage.getItem(SELECTED_LANGUAGE_STORAGE_KEY)
  },
  timezone: {
    default: 'Europe/Berlin'
  },
  defaultBusinessCountries: [
    'AT',
    'BE',
    'BG',
    'HR',
    'CY',
    'CZ',
    'DK',
    'EE',
    'FI',
    'FR',
    'DE',
    'GR',
    'HU',
    'IE',
    'IT',
    'LV',
    'LT',
    'LU',
    'MT',
    'NL',
    'PL',
    'PT',
    'RO',
    'SK',
    'SI',
    'ES',
    'SE',
    'IS',
    'LI',
    'NO',
    'CH',
    'AL',
    'ME',
    'MK',
    'RS',
    'TR',
    'AD',
    'BA',
    'MD',
    'MC',
    'SM',
    'UA',
    'GB',
    'VA',
    'CA',
    'MX',
    'US'
  ]
};

export default defaultConfig;
